let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fhI6j")).then(() => parcelRequire('a58PP'));